module.exports = __webpack_public_path__ + "img/syukyaku-kaisya-001.f36493fd.jpg";